const cache = new Map<string, number>();

export function getCurrencyScaleFactor(
  currency: string,
  locale = "en-GB",
): number {
  const cached = cache.get(currency);
  if (cached !== undefined) return cached;

  try {
    const scale =
      new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
      }).resolvedOptions().maximumFractionDigits ?? 2;
    cache.set(currency, scale);
    return scale;
  } catch {
    cache.set(currency, 2);
    return 2;
  }
}
